import { useCallback, useMemo } from 'react';

import classNames from 'classnames';

import { useAppSelector } from 'mastodon/store';

import { ExternalZone } from './external_zone';
import { LaoChatZone } from './laochat_zone';
import { QuoteZone } from './quote_zone';

const normalizeStatusUrl = status => {
  let url = status?.get('url');

  if (!url && status?.getIn(['account', 'acct']) && status?.get('id')) {
    url = `${window.location.origin}/@${status.getIn(['account', 'acct'])}/${status.get('id')}`;
  }

  if (url?.endsWith('/activity')) {
    return url.replace(/\/activity$/, '');
  }

  return url || window.location.href;
};

const useIsMobile = () => window.innerWidth < 768;

const ShareModal = ({ statusId, onClose }) => {
  const status = useAppSelector(state => state.statuses.get(statusId));
  const isMobile = useIsMobile();
  const statusUrl = useMemo(() => normalizeStatusUrl(status), [status]);

  const close = useCallback(() => {
    onClose?.();
  }, [onClose]);

  if (!status) {
    return null;
  }

  return (
    <div
      className={classNames('modal-root__modal share-modal', {
        'share-modal--sheet': isMobile,
        'share-modal--dialog': !isMobile,
      })}
      role='dialog'
      aria-modal='true'
    >
      <div className='share-modal__content'>
        <QuoteZone status={status} onClose={close} />
        {/* <LaoChatZone statusUrl={statusUrl} /> */}
        <ExternalZone statusUrl={statusUrl} />
      </div>
    </div>
  );
};

export default ShareModal;
